import ContentWithNavigationSidebar from './container'

export default ContentWithNavigationSidebar



// WEBPACK FOOTER //
// ./src/legacy/layouts/ContentWithNavigationSidebar/index.js